<template>
  <v-col cols="12" md="6">
    <v-card class="main-card">
      <v-card-title style="word-break: keep-all">
         {{$t('general.serviceRating')}} {{this.botName}}
      </v-card-title>
      <v-card-text>
        <v-list>
          <v-list-item v-for="item in items"
                       class="item"
                       :key="item.letter">
            <v-list-item-action>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <div class="d-flex align-center"
                       v-on="on"
                       style="cursor: pointer">
                    <span class="letter" :style="item.style">
                    {{item.letter}}
                    </span>

                    <v-icon large
                            :style="item.color"
                            v-text="item.icon">
                    </v-icon>
                  </div>
                </template>

                <span>
                  {{item.tooltip}}
                </span>
              </v-tooltip>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title v-text="item.value"/>
            </v-list-item-content>

          </v-list-item>
        </v-list>

        <div  class="text-right"
              style="font-size: 25px;">
          <span>
            {{`${$t('general.total')}: ${this.total}`}}
          </span>
        </div>

      </v-card-text>
    </v-card>
  </v-col>
</template>

<script>
import conversationsService from '@/services/conversationsService.js'
import { mapGetters } from 'vuex'
export default {
  created () {
    this.getRating()
  },
  computed: {
    ...mapGetters(['datesRange']),
    items () {
      return [
        { value: this.good, icon: 'mdi-emoticon-excited-outline', color: 'color: #0E8D13', letter: 'A.', tooltip: 'Feliz' },
        { value: this.medium, icon: 'mdi-emoticon-neutral-outline', color: ' color: #DCDC77', letter: 'B.', tooltip: 'Neutral' },
        { value: this.bad, icon: 'mdi-emoticon-angry-outline', color: ' color: #F50F0F', letter: 'C.', tooltip: 'Bravo' },
        { value: this.noClassified, icon: 'mdi-head-question-outline', color: ' color: black', letter: 'D.', tooltip: 'No es una respuesta de calificación', style: 'margin-right: 9px' }
      ]
    }
  },
  data () {
    return {
      bad: 0,
      botName: '',
      good: 0,
      medium: 0,
      total: 0,
      noClassified: 0
    }
  },
  methods: {
    async getRating () {
      const appId = this.$store.getters.appUuid
      const companyId = this.$store.getters.companyUuid
      const token = this.$store.getters.token
      const ratingResult = await conversationsService.getRatings(token, companyId, appId, this.datesRange)
      if (!ratingResult) return
      const good = ratingResult.ratings.find(item => {
        return item.key === 'a'
      })
      if (good) this.good = good.count
      else this.good = 0

      const medium = ratingResult.ratings.find(item => {
        return item.key === 'b'
      })
      if (medium) this.medium = medium.count
      else this.medium = 0

      const bad = ratingResult.ratings.find(item => {
        return item.key === 'c'
      })
      if (bad) this.bad = bad.count
      else this.bad = 0

      const noClassified = ratingResult.ratings.find(item => {
        return item.key === 'could not be classified'
      })
      if (noClassified) this.noClassified = noClassified.count
      else this.noClassified = 0

      if (ratingResult.bot) this.botName = ratingResult.bot.name

      this.total = ratingResult.total
    }
  },
  watch: {
    datesRange: {
      handler () {
        this.getRating()
      }
    }
  }
}
</script>

<style scoped>
  .main-card {
    border-radius: 5px !important;
    width: 100% !important;
    height: 100%;
  }
  .letter {
    margin-right: 10px;
    font-size: 20px;
    font-family: 'Montserrat', sans-serif;
  }
  .v-list-item__icon {
    align-items: center !important;
  }
  .v-list-item__title {
    font-size: 25px !important;
    font-weight: 200!important;
  }
  .item {
    height: 0px !important;
  }

</style>
